<template>
    <v-card flat>
        <v-card-text>
            <v-row>
                <v-col cols="12" sm="6">
                    <v-card-title>High Performance Awards</v-card-title>

                    <v-alert icon="info" text>
                        For levels 5 - Elite: The athlete (boys & girls combined) in each level, on each event with the
                        highest score will be awarded.
                    </v-alert>

                    <v-expansion-panels multiple accordion>
                        <v-expansion-panel v-for="(level, lIndex) in transformedHighPerformanceAwards" :key="lIndex">
                            <v-expansion-panel-header> {{ level.level }} </v-expansion-panel-header>
                            <v-expansion-panel-content>
                                <v-list dense>
                                    <v-list-item-group>
                                        <v-list-item v-for="(event, eIndex) in level.events" :key="eIndex">
                                            <v-list-item-content>
                                                <v-subheader class="pl-0 ml-0">
                                                    {{ event.event }}
                                                </v-subheader>
                                                <v-list-item-title>
                                                    <div v-if="event.results?.length > 0" class="d-flex">
                                                        <scorsync-avatar
                                                            :person="event.results[0].athlete"
                                                            type="athlete"
                                                        />

                                                        <div class="pt-1 pl-3">
                                                            <div>
                                                                {{ event.results[0].athlete.name }}
                                                                -
                                                                {{ event.results[0].prelims_score }}
                                                            </div>
                                                            <div>
                                                                {{ event.results[0].club.name }}
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div v-else class="font-italic">No results</div>
                                                </v-list-item-title>
                                            </v-list-item-content>
                                        </v-list-item>
                                    </v-list-item-group>
                                </v-list>
                            </v-expansion-panel-content>
                        </v-expansion-panel>
                    </v-expansion-panels>
                </v-col>

                <v-col cols="12" sm="6">
                    <v-card-title>Super Star Awards</v-card-title>

                    <v-alert icon="info" text>
                        For levels 1 - 4: The athletes (boys & girls combined) in each level, on each event with the
                        highest 3 scores will be awarded.
                    </v-alert>

                    <v-expansion-panels multiple accordion>
                        <v-expansion-panel v-for="(level, lIndex) in transformedSuperStarAwards" :key="lIndex">
                            <v-expansion-panel-header> {{ level.level }} </v-expansion-panel-header>
                            <v-expansion-panel-content>
                                <v-list dense>
                                    <v-list-item-group>
                                        <v-list-item v-for="(event, eIndex) in level.events" :key="eIndex">
                                            <v-list-item-content>
                                                <v-subheader class="pl-0 ml-0">
                                                    {{ event.event }}
                                                </v-subheader>
                                                <v-list-item-title>
                                                    <div
                                                        v-for="(result, index) in event.results"
                                                        :key="result.id"
                                                        class="d-flex my-3"
                                                    >
                                                        <div class="pt-2 mr-4 text-h6">
                                                            {{ index + 1 }}
                                                        </div>
                                                        <scorsync-avatar :person="result.athlete" type="athlete" />

                                                        <div class="pt-1 pl-3">
                                                            <div>
                                                                {{ result.athlete.name }}
                                                                -
                                                                {{ result.prelims_score }}
                                                            </div>
                                                            <div>
                                                                {{ result.club.name }}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </v-list-item-title>
                                            </v-list-item-content>
                                        </v-list-item>
                                    </v-list-item-group>
                                </v-list>
                            </v-expansion-panel-content>
                        </v-expansion-panel>
                    </v-expansion-panels>
                </v-col>
            </v-row>
        </v-card-text>
    </v-card>
</template>
<script>
import ScorsyncAvatar from '@/Components/ScorsyncAvatar.vue';
import Athlete from '@/Models/Athlete.js';

export default {
    name: 'ExtraAwards',

    components: { ScorsyncAvatar },

    props: {
        rankings: {
            type: Object,
            required: true,
        },
    },

    computed: {
        highPerformanceAwards() {
            // this.rankings is an object with keys for each level. I want to discard levels 1-4 here
            const removeLevels = ['Level 1', 'Level 2', 'Level 3', 'Level 4'];

            return Object.fromEntries(Object.entries(this.rankings).filter(([level]) => !removeLevels.includes(level)));
        },

        transformedHighPerformanceAwards() {
            return Object.entries(this.highPerformanceAwards).map(([level, events]) => ({
                level,
                events: Object.values(events).map(event => ({
                    event: event.event,
                    results: event.results,
                })),
            }));
        },

        superStarAwards() {
            // this.rankings is an object with keys for each level. I want to discard levels 1-4 here
            const onlyLevels = ['Level 1', 'Level 2', 'Level 3', 'Level 4'];

            return Object.fromEntries(Object.entries(this.rankings).filter(([level]) => onlyLevels.includes(level)));
        },

        transformedSuperStarAwards() {
            return Object.entries(this.superStarAwards).map(([level, events]) => ({
                level,
                events: Object.values(events).map(event => ({
                    event: event.event,
                    results: event.results,
                })),
            }));
        },
    },

    methods: {
        async athleteModel(result) {
            return;
            const insertion = await Athlete.insert({ data: result.athlete });

            console.log(insertion);
        },
    },
};
</script>
